module.exports = __webpack_public_path__ + "static/media/selective-focus-photography-of-people-having-a-toast-1269043.800516e7.jpg";